import { auth } from '../../firebase/config';

const DEFAULT_BASE_URL = 'https://us-central1-gla-platform-2024.cloudfunctions.net/userManagement';
const functionsBaseUrl = process.env.REACT_APP_FUNCTIONS_BASE_URL || DEFAULT_BASE_URL;

const buildUrl = (path) => {
  const base = functionsBaseUrl.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

const getHeaders = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User must be authenticated to call admin API');
  }

  const token = await currentUser.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

const handleResponse = async (response) => {
  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = { success: false, error: 'Invalid JSON response' };
  }

  if (!response.ok) {
    const err = new Error(payload?.error || `Request failed with status ${response.status}`);
    err.status = response.status;
    err.data = payload;
    throw err;
  }

  return payload;
};

const request = async (method, path, body) => {
  const headers = await getHeaders();
  const options = {
    method,
    headers,
  };

  if (body && method !== 'GET' && method !== 'DELETE') {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(buildUrl(path), options);
  return handleResponse(response);
};

export const fetchUsers = () => request('GET', '/users');

export const createUser = (payload) => request('POST', '/users', payload);

export const updateUser = (uid, payload) => request('PUT', `/users/${uid}`, payload);

export const updateUserRole = (uid, role) => request('PATCH', `/users/${uid}/role`, { role });

export const updateUserSubscription = (uid, payload) => request('PATCH', `/users/${uid}/subscription`, payload);

export const deleteUser = (uid) => request('DELETE', `/users/${uid}`);

const userManagementApi = {
  fetchUsers,
  createUser,
  updateUser,
  updateUserRole,
  updateUserSubscription,
  deleteUser,
};

export default userManagementApi;

